// GENERATED FILE -- DO NOT EDIT BY HAND.
// Regenerate with: npm run learning:generate-preview-fixture (from shopify/)
// Source: shopify/data/lessons/*.json, filtered to
// shopify/data/public-launch-lessons.json and ordered within each category
// by lesson_id. Consumed by learning-hub-lesson-position.js on the
// production lesson template for the "Lesson X of Y" chip and the
// Previous/Next lesson navigation.
window.OOLearningHubLessonPositionData = {
  "choosing-a-mask": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 1,
    "total": 7,
    "previous": null,
    "next": {
      "handle": "mask-fit-positioning-adjustment",
      "title": "Mask Fit, Positioning & Adjustment",
      "index": 2
    }
  },
  "mask-fit-positioning-adjustment": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 2,
    "total": 7,
    "previous": {
      "handle": "choosing-a-mask",
      "title": "Choosing a Mask",
      "index": 1
    },
    "next": {
      "handle": "mask-preparation-defogging-care",
      "title": "Mask Preparation, Defogging & Care",
      "index": 3
    }
  },
  "mask-preparation-defogging-care": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 3,
    "total": 7,
    "previous": {
      "handle": "mask-fit-positioning-adjustment",
      "title": "Mask Fit, Positioning & Adjustment",
      "index": 2
    },
    "next": {
      "handle": "choosing-and-setting-up-a-snorkel",
      "title": "Choosing and Setting Up a Snorkel",
      "index": 4
    }
  },
  "choosing-and-setting-up-a-snorkel": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 4,
    "total": 7,
    "previous": {
      "handle": "mask-preparation-defogging-care",
      "title": "Mask Preparation, Defogging & Care",
      "index": 3
    },
    "next": {
      "handle": "choosing-fins",
      "title": "Choosing Fins",
      "index": 5
    }
  },
  "choosing-fins": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 5,
    "total": 7,
    "previous": {
      "handle": "choosing-and-setting-up-a-snorkel",
      "title": "Choosing and Setting Up a Snorkel",
      "index": 4
    },
    "next": {
      "handle": "exposure-protection-staying-warm",
      "title": "Exposure Protection & Staying Warm",
      "index": 6
    }
  },
  "exposure-protection-staying-warm": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 6,
    "total": 7,
    "previous": {
      "handle": "choosing-fins",
      "title": "Choosing Fins",
      "index": 5
    },
    "next": {
      "handle": "prescription-masks-nearsightedness-farsightedness-lens-selection",
      "title": "Prescription Masks: Nearsightedness, Farsightedness & Lens Selection",
      "index": 7
    }
  },
  "prescription-masks-nearsightedness-farsightedness-lens-selection": {
    "category_handle": "gear-masks-vision",
    "category_title": "Gear, Masks & Vision",
    "index": 7,
    "total": 7,
    "previous": {
      "handle": "exposure-protection-staying-warm",
      "title": "Exposure Protection & Staying Warm",
      "index": 6
    },
    "next": null
  },
  "health-readiness-and-personal-responsibility": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 1,
    "total": 10,
    "previous": null,
    "next": {
      "handle": "golden-rules-for-safer-snorkeling",
      "title": "Golden Rules for Safer Snorkeling",
      "index": 2
    }
  },
  "golden-rules-for-safer-snorkeling": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 2,
    "total": 10,
    "previous": {
      "handle": "health-readiness-and-personal-responsibility",
      "title": "Health, Readiness and Personal Responsibility",
      "index": 1
    },
    "next": {
      "handle": "surface-safety-devices",
      "title": "Surface Safety Devices",
      "index": 3
    }
  },
  "surface-safety-devices": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 3,
    "total": 10,
    "previous": {
      "handle": "golden-rules-for-safer-snorkeling",
      "title": "Golden Rules for Safer Snorkeling",
      "index": 2
    },
    "next": {
      "handle": "pre-snorkel-checklist-and-planning",
      "title": "Pre-Snorkel Checklist and Planning",
      "index": 4
    }
  },
  "pre-snorkel-checklist-and-planning": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 4,
    "total": 10,
    "previous": {
      "handle": "surface-safety-devices",
      "title": "Surface Safety Devices",
      "index": 3
    },
    "next": {
      "handle": "beach-flags-and-surface-warnings",
      "title": "Beach Flags and Surface Warnings",
      "index": 5
    }
  },
  "beach-flags-and-surface-warnings": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 5,
    "total": 10,
    "previous": {
      "handle": "pre-snorkel-checklist-and-planning",
      "title": "Pre-Snorkel Checklist and Planning",
      "index": 4
    },
    "next": {
      "handle": "currents-and-rip-currents",
      "title": "Currents & Rip Currents",
      "index": 6
    }
  },
  "currents-and-rip-currents": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 6,
    "total": 10,
    "previous": {
      "handle": "beach-flags-and-surface-warnings",
      "title": "Beach Flags and Surface Warnings",
      "index": 5
    },
    "next": {
      "handle": "waves-tides-and-surge",
      "title": "Waves, Tides & Surge",
      "index": 7
    }
  },
  "waves-tides-and-surge": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 7,
    "total": 10,
    "previous": {
      "handle": "currents-and-rip-currents",
      "title": "Currents & Rip Currents",
      "index": 6
    },
    "next": {
      "handle": "buddy-communication-and-awareness",
      "title": "Buddy Communication and Awareness",
      "index": 8
    }
  },
  "buddy-communication-and-awareness": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 8,
    "total": 10,
    "previous": {
      "handle": "waves-tides-and-surge",
      "title": "Waves, Tides & Surge",
      "index": 7
    },
    "next": {
      "handle": "breath-hold-safety-co2-and-shallow-water-blackout",
      "title": "Breath-Hold Safety, CO2 & Shallow-Water Blackout",
      "index": 9
    }
  },
  "breath-hold-safety-co2-and-shallow-water-blackout": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 9,
    "total": 10,
    "previous": {
      "handle": "buddy-communication-and-awareness",
      "title": "Buddy Communication and Awareness",
      "index": 8
    },
    "next": {
      "handle": "snorkeling-emergencies-recognition-and-preparedness",
      "title": "Snorkeling Emergencies: Recognition & Preparedness",
      "index": 10
    }
  },
  "snorkeling-emergencies-recognition-and-preparedness": {
    "category_handle": "safety-conditions",
    "category_title": "Safety & Conditions",
    "index": 10,
    "total": 10,
    "previous": {
      "handle": "breath-hold-safety-co2-and-shallow-water-blackout",
      "title": "Breath-Hold Safety, CO2 & Shallow-Water Blackout",
      "index": 9
    },
    "next": null
  },
  "entry-and-exit-techniques": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 1,
    "total": 7,
    "previous": null,
    "next": {
      "handle": "clearing-your-snorkel",
      "title": "Clearing Your Snorkel",
      "index": 2
    }
  },
  "clearing-your-snorkel": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 2,
    "total": 7,
    "previous": {
      "handle": "entry-and-exit-techniques",
      "title": "Entry and Exit Techniques",
      "index": 1
    },
    "next": {
      "handle": "duck-diving-basics",
      "title": "Duck Diving Basics",
      "index": 3
    }
  },
  "duck-diving-basics": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 3,
    "total": 7,
    "previous": {
      "handle": "clearing-your-snorkel",
      "title": "Clearing Your Snorkel",
      "index": 2
    },
    "next": {
      "handle": "mask-clearing-techniques",
      "title": "Mask Clearing Techniques",
      "index": 4
    }
  },
  "mask-clearing-techniques": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 4,
    "total": 7,
    "previous": {
      "handle": "duck-diving-basics",
      "title": "Duck Diving Basics",
      "index": 3
    },
    "next": {
      "handle": "efficient-kicking-techniques",
      "title": "Efficient Kicking Techniques",
      "index": 5
    }
  },
  "efficient-kicking-techniques": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 5,
    "total": 7,
    "previous": {
      "handle": "mask-clearing-techniques",
      "title": "Mask Clearing Techniques",
      "index": 4
    },
    "next": {
      "handle": "relaxed-breathing-and-efficient-movement",
      "title": "Relaxed Breathing & Efficient Movement",
      "index": 6
    }
  },
  "relaxed-breathing-and-efficient-movement": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 6,
    "total": 7,
    "previous": {
      "handle": "efficient-kicking-techniques",
      "title": "Efficient Kicking Techniques",
      "index": 5
    },
    "next": {
      "handle": "floating-and-treading-water",
      "title": "Floating & Treading Water",
      "index": 7
    }
  },
  "floating-and-treading-water": {
    "category_handle": "in-water-skills",
    "category_title": "In-Water Skills",
    "index": 7,
    "total": 7,
    "previous": {
      "handle": "relaxed-breathing-and-efficient-movement",
      "title": "Relaxed Breathing & Efficient Movement",
      "index": 6
    },
    "next": null
  },
  "buoyancy-pressure-and-airspaces": {
    "category_handle": "underwater-science-your-body",
    "category_title": "Underwater Science & Your Body",
    "index": 1,
    "total": 4,
    "previous": null,
    "next": {
      "handle": "light-vision-and-sound-underwater",
      "title": "Light, Vision & Sound Underwater",
      "index": 2
    }
  },
  "light-vision-and-sound-underwater": {
    "category_handle": "underwater-science-your-body",
    "category_title": "Underwater Science & Your Body",
    "index": 2,
    "total": 4,
    "previous": {
      "handle": "buoyancy-pressure-and-airspaces",
      "title": "Buoyancy, Pressure & Airspaces",
      "index": 1
    },
    "next": {
      "handle": "equalizing-basics",
      "title": "Equalizing Basics",
      "index": 3
    }
  },
  "equalizing-basics": {
    "category_handle": "underwater-science-your-body",
    "category_title": "Underwater Science & Your Body",
    "index": 3,
    "total": 4,
    "previous": {
      "handle": "light-vision-and-sound-underwater",
      "title": "Light, Vision & Sound Underwater",
      "index": 2
    },
    "next": {
      "handle": "why-you-get-cold-in-water",
      "title": "Why You Get Cold in Water",
      "index": 4
    }
  },
  "why-you-get-cold-in-water": {
    "category_handle": "underwater-science-your-body",
    "category_title": "Underwater Science & Your Body",
    "index": 4,
    "total": 4,
    "previous": {
      "handle": "equalizing-basics",
      "title": "Equalizing Basics",
      "index": 3
    },
    "next": null
  },
  "types-of-snorkeling-experiences": {
    "category_handle": "marine-life-conservation",
    "category_title": "Marine Life & Conservation",
    "index": 1,
    "total": 3,
    "previous": null,
    "next": {
      "handle": "marine-life-basics",
      "title": "Marine Life Basics",
      "index": 2
    }
  },
  "marine-life-basics": {
    "category_handle": "marine-life-conservation",
    "category_title": "Marine Life & Conservation",
    "index": 2,
    "total": 3,
    "previous": {
      "handle": "types-of-snorkeling-experiences",
      "title": "Types of Snorkeling Experiences",
      "index": 1
    },
    "next": {
      "handle": "coral-conservation-and-responsible-behavior",
      "title": "Coral, Conservation and Responsible Behavior",
      "index": 3
    }
  },
  "coral-conservation-and-responsible-behavior": {
    "category_handle": "marine-life-conservation",
    "category_title": "Marine Life & Conservation",
    "index": 3,
    "total": 3,
    "previous": {
      "handle": "marine-life-basics",
      "title": "Marine Life Basics",
      "index": 2
    },
    "next": null
  }
};
